import { render, staticRenderFns } from "./DepositSuccess.vue?vue&type=template&id=594ac041&"
import script from "./DepositSuccess.vue?vue&type=script&lang=js&"
export * from "./DepositSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports